/**
 * Single source of truth for the "city / location" dimension used by the
 * landing-page CTAs, the booking flow, and the analytics funnel.
 */
export type CitySlug = "columbus" | "atlanta" | "phenix-city";

export const CITY_LABELS: Record<string, string> = {
  columbus: "Columbus, GA",
  atlanta: "Atlanta area (shooting in Columbus, GA)",
  "phenix-city": "Phenix City, AL",
};

/** Short label used for analytics dimensions (no parentheses/noise). */
export const CITY_SHORT: Record<string, string> = {
  columbus: "Columbus GA",
  atlanta: "Atlanta GA",
  "phenix-city": "Phenix City AL",
};

export const cityLabel = (slug?: string | null) =>
  slug ? CITY_LABELS[slug.toLowerCase()] ?? slug : null;

export const cityShort = (slug?: string | null) =>
  slug ? CITY_SHORT[slug.toLowerCase()] ?? slug : null;

const KEY = "ms_booking_city";

export function rememberCity(slug?: string | null) {
  if (typeof window === "undefined" || !slug) return;
  try {
    sessionStorage.setItem(KEY, slug.toLowerCase());
  } catch {
    /* storage may be unavailable */
  }
}

export function recallCity(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/**
 * Build a deep link into the booking flow that lands directly on the live
 * availability calendar (step 2) with the city pre-filled.
 */
export function bookingCityUrl(
  city: string,
  opts: { campaign?: string; source?: string; studio?: string; step?: number } = {},
) {
  const p = new URLSearchParams();
  p.set("city", city);
  p.set("step", String(opts.step ?? 2));
  if (opts.studio) p.set("studio", opts.studio);
  p.set("utm_source", opts.source ?? "site");
  p.set("utm_medium", "cta");
  if (opts.campaign) p.set("utm_campaign", opts.campaign);
  return `/book?${p.toString()}`;
}